"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

var _reducers = require("../../reducers");

var _comments = require("../../actions/comments");

var _constants = require("../../constants");

var _utils = require("../../lib/utils");

var _context = require("../../actions/context");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var useSubmitCommentsInStorage = function useSubmitCommentsInStorage(showComment) {
  var _useContext = (0, _react.useContext)(_AppContext.default),
      imsData = _useContext.imsData,
      cacheComments = _useContext.cacheComments,
      imageCapture = _useContext.imageCapture,
      imageContextData = _useContext.imageContextData,
      asset = _useContext.asset.asset;

  var _useContext2 = (0, _react.useContext)(_CallbackContext.default),
      onNodeChange = _useContext2.onNodeChange;

  var ccxIngest = (0, _useIngest.default)();
  var dispatch = (0, _reducers.useDispatch)(); // submit a top level comment

  (0, _react.useEffect)(function () {
    if (asset && imsData.id) {
      var savedComment = (0, _utils.loadFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN);
      (0, _utils.deleteFromSessionStorage)(_constants.COMMENT_BEFORE_SIGNIN);

      if (savedComment) {
        var _savedComment$annotat, _savedComment$annotat2;

        var bodyValue = savedComment.bodyValue,
            annotationLocation = savedComment.annotationLocation,
            annotatingItmId = savedComment.annotatingItmId,
            id = savedComment.id,
            nodeId = savedComment.nodeId;
        var sectionId = savedComment === null || savedComment === void 0 ? void 0 : (_savedComment$annotat = savedComment.annotationLocation) === null || _savedComment$annotat === void 0 ? void 0 : (_savedComment$annotat2 = _savedComment$annotat.coordinates) === null || _savedComment$annotat2 === void 0 ? void 0 : _savedComment$annotat2.sectionId;
        dispatch((0, _context.contextSaveAnnotationLocation)(annotationLocation.coordinates, annotationLocation.nodeId));
        dispatch((0, _comments.commentsPost)(id, nodeId, bodyValue, cacheComments, annotatingItmId === 'root' ? annotationLocation : undefined, undefined, imageCapture, imageContextData)).then(function (comment) {
          // dont scroll a guest user to the new comment.
          if (!imsData.isGuestUser) {
            showComment(comment.id, true);
          }

          onNodeChange(nodeId, sectionId);
        }).catch(function (error) {
          ccxIngest.fireEvent(ccxIngest.events.commentsFailedToPost(error.status, error.message, false));
        });
      }
    }
  }); // submit reply level comment

  (0, _react.useEffect)(function () {
    if (asset && imsData.id) {
      var savedComment = (0, _utils.loadFromSessionStorage)(_constants.REPLY_BEFORE_SIGNIN);
      (0, _utils.deleteFromSessionStorage)(_constants.REPLY_BEFORE_SIGNIN);

      if (savedComment) {
        var _parentCommentData$ta, _parentCommentData$ta2;

        var bodyValue = savedComment.bodyValue,
            id = savedComment.id,
            nodeId = savedComment.nodeId,
            parentCommentData = savedComment.commentData;
        var sectionId = parentCommentData === null || parentCommentData === void 0 ? void 0 : (_parentCommentData$ta = parentCommentData.target) === null || _parentCommentData$ta === void 0 ? void 0 : (_parentCommentData$ta2 = _parentCommentData$ta.selector) === null || _parentCommentData$ta2 === void 0 ? void 0 : _parentCommentData$ta2.sectionId;
        dispatch((0, _comments.postReply)(id, bodyValue, parentCommentData.id, null, cacheComments)).then(function (reply) {
          if (parentCommentData.unmapped) {
            dispatch((0, _context.contextSetUnmappedView)(true));
          } // dont scroll a guest user to the reply.


          if (!imsData.isGuestUser) {
            showComment(reply.id, true);
          }

          onNodeChange(nodeId, sectionId);
        }).catch(function (error) {
          ccxIngest.fireEvent(ccxIngest.events.commentsFailedToPost(error.status, error.message));
        });
      }
    }
  });
};

var _default = useSubmitCommentsInStorage;
exports.default = _default;